import "../Page/Events.css"
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import debateTable from "../img/debateTable2.png";
// import podiumImage from "../img/podiumOnStage.png";
import comingsoon from "../img/ComingSoon.png";
import background from "../img/eventsBackground.jpg";
import insta from "../img/insta.png";
import facebook from "../img/facebook.png";
import mail from "../img/mail.png";

// Sample event data
const events = [
  {
    id: 1,
    title: "Deliberative Debate council",
    date: "2025-07-01",
    image: debateTable,
    active: true,
  },
  {
    id: 2,
    // title: "Coming soon",
    // date: "0000-00-00",
    image: comingsoon,
    active: false,
  },
  {
    id: 3,
    // title: "Coming soon",
    // date: "0000-00-00",
    image: comingsoon,
    active: false,
  },
  {
    id: 4,
    // title: "Coming soon",
    // date: "0000-00-00",
    image: comingsoon,
    active: false,
  },
  {
    id: 5,
    // title: "Coming soon",
    // date: "0000-00-00",
    image: comingsoon,
    active: false,
  }
];

function Events() {
  const navigate = useNavigate();

  const handleCardClick = (event) => {
    if (event.active) {
      navigate(`/events/${event.id}`);
    }
  };

  return (
    <div className="events-background">
      <div className="Background-overlay-container"><img src={background} alt="background" className="Background-overlay"/></div>
        <div className="event-card-container">
        <div className="event-card-container-title">
          <h1>Events</h1>
        </div>
        <div className="carousel-container">
        {events.map((event) => (
          <div
            className={`event-card${event.active ? '' : ' inactive'}`}
            key={event.id}
            onClick={() => handleCardClick(event)}
            style={{ cursor: event.active ? 'pointer' : 'not-allowed' }}
          >
            <img src={event.image} alt={event.title} className="event-image" />
            <h3 className="event-title">{event.title}</h3>
            <p className="event-date">{event.date}</p>
          </div>
        ))}
      </div>
      </div>
      <Link to="/events/1" className="recent-event">
        <div className="recent-event-title">
          <h1>Next Event</h1>
        </div>
        <div className="recent-event-background"> 
        <div className="recent-event-list">
          <div className="recent-event-card">
            <div className="recent-event-image" >
            <div className="recent-event-name-container">
            <h2 className="recent-event-name">{events[0].title}</h2>
            <p className="recent-event-date">{events[0].date}</p>
            <p className="recent-event-desc">Deliberative Debate Council (DDC) is a unique, value-based committee format inspired by Lincoln-Douglas and Open Flow debate styles. It emphasizes logic, ethical reasoning, and clash of values over traditional diplomacy. Delegates present structured arguments, engage in timed rebuttals, and face direct questioning, all in a moderated, courtroom-style environment. The goal is to defend your value framework and persuade the room—not negotiate, but debate.</p>
            </div>
            </div>
          </div>
        </div>
      </div>
      </Link>
      <div className="information">
                    <div className="links">
                        <a href="https://www.instagram.com/unisfera_mun/"><img src={insta} alt="insta" className="image insta"></img></a>
                        <a href="https://www.facebook.com/"><img src={facebook} alt="facebook" className="image facebook"></img></a>
                        <a href="mailto:unisferamodelunitednations@gmail.com"><img src={mail} alt="mail" className="image mail"></img></a>
                        
                    </div>
                    <div className="copyright">© 2025 Unisfera, Inc. All Rights Reserved.</div>
                    </div>
            </div>  
  );
}

export default Events